import { createContext, useContext, ReactNode } from "react";
import { TopicCard } from "./types";
import { MarkdownCard } from "./markdown/MarkdownCard";
import { createCompositeCard } from "./composite/CompositeCard";

const INITIAL_REGISTRY: Record<string, TopicCard> = {
  markdown: MarkdownCard,
  composite: createCompositeCard([]),
  // composite will be added in the provider
};

const CardRegistryContext =
  createContext<Record<string, TopicCard>>(INITIAL_REGISTRY);

export function CardRegistryProvider({
  children,
  registry,
}: {
  children: ReactNode;
  registry?: Record<string, TopicCard>;
}) {
  return (
    <CardRegistryContext.Provider value={registry || INITIAL_REGISTRY}>
      {children}
    </CardRegistryContext.Provider>
  );
}

export function useCardRegistry() {
  const registry = useContext(CardRegistryContext);
  if (!registry) {
    throw new Error(
      "useCardRegistry must be used within a CardRegistryProvider"
    );
  }

  return {
    getCard: (card: string | { id?: string } | undefined) => {
      if (!card) return undefined;
      if (typeof card === "string") {
        return registry[card];
      }
      if (typeof card === "object" && card.id) {
        return registry[card.id];
      }
      return undefined;
    },
    getAllCards: () => Object.values(registry),
  };
}
